import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { createInlineMarkupRegistry, EditableText } from '@/components/block-primitives';
import type { ArtifactType } from '../../store/types';
const markup = createInlineMarkupRegistry([]);
type ReportFileInstructionsProps = {
  format: Exclude<ArtifactType, 'markdown'>;
  instructions: string;
  editable: boolean;
  onChange: (instructions: string) => void;
};

// A PDF or CSV viewer can't draw report sections, so those formats take plain instructions instead.
const ReportFileInstructions = t0 => {
  const $ = _c(19);
  const {
    format,
    instructions,
    editable,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.report"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== format || $[2] !== t) {
    t2 = t(_temp, {
      format: format.toUpperCase()
    });
    $[1] = format;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <p className="text-body-2 text-tertiary">{t2}</p>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp2);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t) {
    t5 = t(_temp3);
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== editable || $[11] !== instructions || $[12] !== onChange || $[13] !== t4 || $[14] !== t5) {
    t6 = <EditableText as="div" block={true} multiline={true} optional={true} className="min-h-24 rounded-md border border-tertiary bg-primary p-4 text-body-2 text-primary opacity-100!" registry={markup} value={instructions} label={t4} placeholder={t5} editable={editable} onSubmit={onChange} />;
    $[10] = editable;
    $[11] = instructions;
    $[12] = onChange;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[16] = t3;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default ReportFileInstructions;
function _temp($) {
  return $.fileInstructions;
}
function _temp2($_0) {
  return $_0.instructionsLabel;
}
function _temp3($_1) {
  return $_1.instructionsPlaceholder;
}